export const REGISTER = 'REGISTER';

export const SET_INTL_DATA = 'SET_INTL_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const UPDATE_USER_LANG = 'UPDATE_USER_LANG';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const RESET_EMAIL_CHANGED = 'RESET_EMAIL_CHANGED';
export const SET_HELP_SEEN = 'SET_HELP_SEEN';
export const SET_HELP_DISMISSED = 'SET_HELP_DISMISSED';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD_CHANGED = 'RESET_PASSWORD_CHANGED';
export const SEND_PASSWORD_RESET_TOKEN = 'SEND_PASSWORD_RESET_TOKEN';
export const SET_PASSWORD_RESET_TOKEN = 'SET_PASSWORD_RESET_TOKEN';
export const CLEAR_LOST_PASSWORD_STATE = 'CLEAR_LOST_PASSWORD_STATE';
export const RESET_PASSWORD = 'RESET_PASSWORD';

export const RETRIEVE_ALL_ACTIONS = 'RETRIEVE_ALL_ACTIONS';
export const RETRIEVE_USER_ACTIONS = 'RETRIEVE_USER_ACTIONS';
export const RETRIEVE_USER_RESPONSES = 'RETRIEVE_USER_RESPONSES';
export const UPDATE_ACTION_RESPONSE = 'UPDATE_ACTION_RESPONSE';
export const RETRIEVE_CAMPAIGN_ACTIONS = 'RETRIEVE_CAMPAIGN_ACTIONS';

export const RETRIEVE_GROUP = 'RETRIEVE_GROUP';
export const RETRIEVE_GROUP_MEMBERS = 'RETRIEVE_GROUP_MEMBERS';

export const RETRIEVE_ALL_CAMPAIGNS = 'RETRIEVE_ALL_CAMPAIGNS';
export const RETRIEVE_CAMPAIGN = 'RETRIEVE_CAMPAIGN';

export const RETRIEVE_USER_ASSIGNMENTS = 'RETRIEVE_USER_ASSIGNMENTS';

export const RETRIEVE_SURVEY = 'RETRIEVE_SURVEY';

export const RETRIEVE_ORGANIZATION = 'RETRIEVE_ORGANIZATION';
export const RETRIEVE_RECOMMENDED_ORGANIZATIONS = 'RETRIEVE_RECOMMENDED_ORGANIZATIONS';
export const RETRIEVE_USER_MEMBERSHIPS = 'RETRIEVE_USER_MEMBERSHIPS';
export const DELETE_USER_MEMBERSHIP = 'DELETE_USER_MEMBERSHIP';

export const FOLLOW_ORGANIZATION = 'FOLLOW_ORGANIZATION';
export const UNFOLLOW_ORGANIZATION = 'UNFOLLOW_ORGANIZATION';
export const RETRIEVE_USER_FOLLOWING = 'RETRIEVE_USER_FOLLOWING';



// WEBPACK FOOTER //
// ./src/actions/index.js